import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/core/services/config.service';
import { UsersService } from '@app/core/services/users.service';
import { GlobalConstants } from '@app/portal/global-constants';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-footer-public',
  templateUrl: './footer-public.component.html'
})

export class FooterPublicComponent implements OnInit {
  appTitle = GlobalConstants.appInfo.appTitle;
  appYear: number = new Date().getFullYear();
  appVersion?: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient, private readonly usersService: UsersService) { }

  ngOnInit(): void {
    let publicPath = this.configService.appConfig.api.publicPath;

    firstValueFrom(this.httpClient.get(`${publicPath}/uo/version`, { responseType: 'text' }))
      .then(response =>
        this.appVersion = response);

  }
}
